export default __webpack_public_path__ + "static/media/Nestjs.8ac1277e.png";